module.exports = __webpack_public_path__ + "img/thankYou.8f9d0d30.png";